import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, tap } from 'rxjs';
import { IProveedoresEelement } from '../../interfaces/proveedores';
import { environment } from '../../../environments/environment';

let ELEMENT_DATA: IProveedoresEelement[] = [];

@Injectable({
  providedIn: 'root'
})
export class CuentasService {

  constructor(private http:HttpClient ) {

  }
  
  getLength(filter: string) {
    return of(this.getElement('').length)
      .pipe(delay(500), tap(_ => {  }));
  }

  getData(page: number, pageSize: number, sortField: string, sortDirection: string) {
    const factor = sortDirection == 'desc' ? -1 : sortDirection == 'asc' ? 1 : 0
    return factor ? of(this.getElement('')
      .sort((a: any, b: any) => a[sortField] > b[sortField] ? -factor : factor)
      .slice((page - 1) * pageSize, page * pageSize)).pipe(
        delay(500), tap(_ => { })) :
      of(this.getElement('')
        .slice((page - 1) * pageSize, page * pageSize)).pipe(
          delay(500), tap(_ => { }))
  }

  getElement(filter: string) {
    return !filter ? [...ELEMENT_DATA] : ELEMENT_DATA.filter(x => x.folio.indexOf(filter) >= 0)
  }

  setData(body: any) {
    ELEMENT_DATA = []
    ELEMENT_DATA = body
  }

  getInfo(){
    return this.data
  }

  data = []
  
  getCuentasExternas(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}lista-cuentas-externas`, body);
  }

  getCuentasInternas(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}lista-cuentas-internas`, body);
  }

  descargarCuentasInternas(body){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}descargar-layoutcinterna`);
  }

  descargarCuentasExternas(body){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}descargar-layoutcexterna`);
  }

  descargarCuentasInternasSeleccionadas(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}download_cinterna`, body);
  }

  descargarCuentasExternasSeleccionadas(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}download_cexterna`, body);
  }

  descargarReporteCuentasBanco(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}reporte-cuentas-banco`, body);
  }

  tiposCuenta(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}account-types`);
  }

}